module.exports = __webpack_public_path__ + "img/the-netherlands-stomach-cancer-male.5de61676.png";